import { ApiService } from "../common/services/api.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import saveAs from "file-saver";

@Injectable({
  providedIn: "root",
})
export class AdministratorService {
  loader: boolean;
  constructor(private http: HttpClient, private apiService: ApiService) {}

  async getData(listname): Promise<any> {
    const result = await this.apiService.getData(listname);
    this.loader = false;
    return result;
  }

  async postDataForSync(data, listname, showLoader = true) {
    const result = await this.apiService.postDataForSync(data, listname, showLoader);
    this.loader = false;
    return result;
  }

  async getDataByID(listname, id: number): Promise<any> {
    const result = await this.apiService.getDataByID(listname, id);
    this.loader = false;
    return result;
  }

  async insertData(data, listname) {
    const result = await this.apiService.postData(data, listname);
    this.loader = false;
    return result;
  }


    async updateData(data, id, listname) {
    const result = await this.apiService.updateData(data, id, listname);
    this.loader = false;
    return result;
  }

  async deleteData(id: number, listname) {
    const result = await this.apiService.deleteData(id, listname);
    this.loader = false;
    return result;
  }

  async postData(data, listname, showLoader = true) {
    const result = await this.apiService.postData(data, listname, showLoader);
    this.loader = false;
    return result;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    saveAs(data, fileName + EXCEL_EXTENSION);
  }

}
